import { getGrpcPromise } from '@monorepo/grpc';

import { ExchangeRateService } from '@spilca/order_ts/v1/order_web/exchange_rate_web_pb_service';
import { GetExchangeRateByCurrencyRequest } from '@spilca/order_ts/v1/order/model_exchange_rate_pb';

const getExchangeRate = (d: any) => {
  const getCurrencyExchangeRate = getGrpcPromise(
    ExchangeRateService.GetExchangeRateByCurrency
  );

  const request = new GetExchangeRateByCurrencyRequest();
  request.setCurrency(d.currency);
  request.setBasicCurrency(d.basicCurrency);
  return getCurrencyExchangeRate(request);
};

export default getExchangeRate;
